import { AlertIcon } from '@approvalmax/ui';
import { Alert, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { verifiedDirectorOwnerRequiredError } from '../../constants';
import { messages } from './PersonsValidationError.messages';
import { PersonsValidationErrorProps } from './PersonsValidationError.types';

export const PersonsValidationError = memo<PersonsValidationErrorProps>((props) => {
    const { message } = props;

    if (!message) {
        return null;
    }

    if (message === verifiedDirectorOwnerRequiredError) {
        return (
            <Alert
                data-qa='at-least-one-director-required-error'
                alignItems='center'
                color='red20'
                size='small'
                startIcon={<AlertIcon />}
            >
                {messages.atLeastOne}
            </Alert>
        );
    }

    return (
        <Text font='body' fontSize='xsmall' fontWeight='regular' color='red100'>
            {message}
        </Text>
    );
});

PersonsValidationError.displayName = 'PersonsValidationError';
